import { render, staticRenderFns } from "./newsadd.vue?vue&type=template&id=3470adee&"
import script from "./newsadd.vue?vue&type=script&lang=js&"
export * from "./newsadd.vue?vue&type=script&lang=js&"
import style0 from "./newsadd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports